var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"recaptcha"}),(_vm.loading)?_c('div',{staticClass:"latestShimmerDesign",staticStyle:{"width":"304px","height":"78px"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }